import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Constant } from '../../../../shared/common/constant';

export function phoneFormlyValidator(
  c: AbstractControl
): ValidationErrors | null {
  if (!c.value) {
    return null;
  }

  const valueWithoutWhitespace = c.value.replace(/ |\+1/g, '');

  return Constant.PHONE_NUMBER_RULES.pattern.test(valueWithoutWhitespace)
    ? null
    : { phone: true };
}
